<template>
	<el-tree id="1" :props="treeProps" :load="loadNode" lazy @node-contextmenu="rightClick">
		<span class="custom-tree-node" slot-scope="{ node, data }">
			<span v-if="node.level === 1" class="no-wrap">
				<icon name="atlas" style="color: 777"/>
				{{data.name}}
			</span>
			<span v-if="node.level === 2">
				<icon name="database" style="color: 777"/>
				{{data.name}}
			</span>
			<span v-if="node.level === 3">
				<template v-if="node.data.data.type === 'TABLE'">
					<icon name="table" style="color: 777"/>
				</template>
				<template v-if="node.data.data.type === 'VIEW'">
					<icon name="eye" style="color: 777"/>
					<!--
					<icon label="No Photos">
						<icon name="table" style="color: 777"/>
						<icon name="eye" scale="0.5" class="alert"></icon>
					</icon>
					-->
				</template>
				{{data.name}}
			</span>
			<a-column-tree-item v-if="node.level === 4" :column="data.data"/>
		</span>
	</el-tree>
</template>

<script>
import {HTTP} from '../../services/HttpService'
export default {
  name: 'catalog-viewer',
  data () {
    return {
      root: {},
      treeProps: {
        isLeaf: 'leaf'
      },
      catalogs: []
    }
  },
  mounted: function () {
  },
  methods: {
    rightClick (event, node, nodeProperty, nodeTree) {
      if (node.data.type === 'TABLE') {
        this.$emit('tableClicked', node.data)
      }
    },
    loadNode (node, resolve) {
      switch (node.level) {
        case 0: // catalog level
          this.root = node
          this.loadCatalogs(resolve)
          break
        case 1: // schema level
          this.loadSchemas(node.data.id, resolve)
          break
        case 2: // table level
          this.loadTables(node.parent.data.id, node.data.id, resolve)
          break
        case 3: // column level
          this.loadColumns(node.parent.parent.data.id, node.parent.data.id, node.data.id, resolve)
          break
      }
      resolve([])
    },
    loadCatalogs (resolve) {
      HTTP.get('api/metadata/catalogs', {
        params: {
          page: 0,
          rowsPerPage: 100000,
          search: ''
        }
      })
      .then(response => {
        this.catalogs = response.data.list
        let nodes = []
        this.catalogs.forEach(catalog => {
          let node = {
            id: catalog.id,
            name: catalog.name,
            label: catalog.name,
            data: catalog,
            leaf: false
          }
          nodes.push(node)
        })
        resolve(nodes)
      })
    },
    loadSchemas (catalogId, resolve) {
      HTTP.get('api/metadata/catalogs/' + catalogId + '/schemas', {
        params: {
          page: 0,
          rowsPerPage: 100000,
          search: ''
        }
      })
      .then(response => {
        let schemas = response.data.list
        let nodes = []
        schemas.forEach(schema => {
          let node = {
            id: schema.id,
            name: schema.name,
            label: schema.name,
            data: schema,
            leaf: false
          }
          nodes.push(node)
        })
        resolve(nodes)
      })
    },
    loadTables (catalogId, schemaId, resolve) {
      HTTP.get('api/metadata/catalogs/' + catalogId + '/schemas/' + schemaId + '/tables', {
        params: {
          page: 0,
          rowsPerPage: 100000,
          search: ''
        }
      })
      .then(response => {
        let tables = response.data.list
        let nodes = []
        tables.forEach(table => {
          let node = {
            id: table.id,
            name: table.name,
            label: table.name,
            data: table,
            leaf: false
          }
          nodes.push(node)
        })
        resolve(nodes)
      })
    },
    loadColumns (catalogId, schemaId, tableId, resolve) {
      HTTP.get('api/metadata/catalogs/' + catalogId + '/schemas/' + schemaId + '/tables/' + tableId + '/columns', {
        params: {
          page: 0,
          rowsPerPage: 100000,
          search: ''
        }
      })
      .then(response => {
        let columns = response.data.list
        let nodes = []
        columns.forEach(column => {
          let node = {
            id: column.id,
            name: column.name,
            label: column.name,
            data: column,
            leaf: true
          }
          nodes.push(node)
        })
        resolve(nodes)
      })
    }
  },
  updated () {
    this.root.loaded = false
    this.root.expand()
  }
}
</script>

<style  lang="css"  scoped>
.el-tree {
	min-width: 100%;
	display: inline-block;
}

.tree {
	overflow:auto;
	max-height: 500px;
}
</style>



// WEBPACK FOOTER //
// CatalogViewer.vue?5ff514b9